module.exports = __webpack_public_path__ + "img/Paper.21907c46.svg";